import React from 'react';

export default function TableHead({heads = {}}) {
    return (
      <thead>
        <tr>{heads.map(({text,tooltipName, ...rest}) => <th key={text} title = {tooltipName} {...rest}>{text}</th>)}</tr>
      </thead>
    )
  }